"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortGroups = exports.getLocalizedSortOption = exports.SORT_OPTIONS = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const sort_1 = require("../../service/utils/sort");
exports.SORT_OPTIONS = [bridge_schema_1.SortType.A_Z, bridge_schema_1.SortType.Z_A, bridge_schema_1.SortType.Recent];
const getLocalizedSortOption = (sortType, t) => {
    switch (sortType) {
        case bridge_schema_1.SortType.A_Z:
            return t(i18n_1.Strings.common.sort.groupAZ);
        case bridge_schema_1.SortType.Z_A:
            return t(i18n_1.Strings.common.sort.groupZA);
        case bridge_schema_1.SortType.Recent:
            return t(i18n_1.Strings.common.sort.recent).toUpperCase();
        default:
            return t(i18n_1.Strings.common.sort.az);
    }
};
exports.getLocalizedSortOption = getLocalizedSortOption;
const sortGroups = (sortType, groups, setGroups) => {
    switch (sortType) {
        case bridge_schema_1.SortType.A_Z:
            setGroups((0, sort_1.sortNameAsc)(groups));
            break;
        case bridge_schema_1.SortType.Z_A:
            setGroups((0, sort_1.sortNameAsc)(groups).reverse());
            break;
        case bridge_schema_1.SortType.Recent:
            setGroups((0, sort_1.sortMostRecent)(groups));
            break;
    }
};
exports.sortGroups = sortGroups;
